<app-task-list [taskListConfiguration]="taskListConfiguration" [taskListMode]="taskListMode"></app-task-list>
